module.exports = __webpack_public_path__ + "img/a1-since-1999-end.1b73161d.jpg";